import { connect } from "react-redux";
import HotoMainForm from "./hotoMainForm";
import { bindActionCreators } from "redux";
import { getHotoMaterialList, saveHotoMaintenance,getHotoDetails } from "services/redux/maintenance/hoto/action";
import {getMaterial} from "../../../services/redux/maintenance/rmTicket/action";
import {
  documentUploadUrlPublic,
  imageUploadUrlPublic
} from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  hotoMaterialList: state.HotoReducer.hotoMaterialList,
  documentUrlData: state.fileUploadReducer.imageUrlData,
  hotoDetails: state.HotoReducer.hotoDetails,
  allMaterialList: state.rmTicketReducer.materials
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getHotoMaterialList,
      imageUploadUrlPublic,
      saveHotoMaintenance,
      getHotoDetails,
      getMaterial
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HotoMainForm);
